import { API_ENDPOINT } from '../config';

export default function(id) {
    return fetch(`${API_ENDPOINT}/performances/${id}/ticket-sets/`);
}
